module.exports = __webpack_public_path__ + "static/media/maria.92c91512.JPG";